"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPluginStateView = void 0;
/**
 * Builds a `PluginStateView` for the plugin's own sub-tree under
 * `state.game.plugins[<pluginId>]`.
 *
 * @param pluginId The id of the calling plugin.
 * @returns A view exposing typed `select(getter)`.
 */
const createPluginStateView = (pluginId) => ({
    select: (getter) => (rootState) => getter(rootState.game.plugins[pluginId]),
});
exports.createPluginStateView = createPluginStateView;
